import { query, storage } from "@sinao/core-js";

const downpayment = {
	state: {
		table: {},
		downpayment: {
			totals: {
				exclTax: 0,
				vat: 0,
				inclTax: 0
			}
		},
		depositPercent: null,
		depositAmount: null,
		depositValue: null,
		invoices: [],
		searchedValues: []
	},
	getters: {
		getTableIds(state) {
			const ids = [];

			Object.values(state.table).forEach(entry => {
				if (entry && entry.data) {
					const { id } = entry.data;

					if (id) {
						ids.push(id);
					}
				}
			});

			return ids;
		}
	},
	mutations: {
		downpaymentTable(state, payload) {
			state.table = payload;
		},
		downpayment(state, payload) {
			state.downpayment = payload;
		},
		depositPercent(state, payload) {
			state.depositPercent = payload;
		},
		depositAmount(state, payload) {
			state.depositAmount = payload;
		},
		depositValue(state, payload) {
			state.depositValue = payload;
		},
		invoices(state, payload) {
			state.invoices = payload;
		},
		createRow(state, payload) {
			let { id, row } = payload || {};

			if (!id) {
				id = `downpayment${Math.floor(Math.random() * 10000 + 1)}`;
			}

			this._vm.$set(state.table, id, {
				id,
				data: row
			});
		},
		addToInvoices(state, invoices) {
			state.invoices.push(...invoices);
		},
		updateSeachedValues(state, newSearch) {
			state.searchedValues.push(newSearch);
		}
	},
	actions: {
		createDownpaymentRows({ commit }, payload) {
			if (payload && payload.length > 0) {
				payload.forEach(data => {
					commit("createRow", { id: null, row: data });
				});

				commit("showDownpaymentTable", true);
				commit("createRow", null);
			}
		},
		async invoices(
			{ commit, rootState },
			{ appId, clientId = null, type = null }
		) {
			try {
				const { app } = rootState;
				let params = {
					appId,
					"expand[0]": "contact",
					"limit": 10
				};

				if (!clientId) {
					const storeInvoices = await storage.get(
						"downpayments_invoices",
						app.id
					);

					// Return the data in the store if it's available
					if (storeInvoices) {
						commit("invoices", storeInvoices.data);
					}
				} else {
					params = {
						...params,
						"filters[0][name]": `customer_${type}_id`,
						"filters[0][comparator]": "=",
						"filters[0][value]": `${clientId}`
					};
				}

				return query({
					operationId: "app.documents.sales.invoices.list",
					params
				}).then(({ data }) => {
					if (data) {
						commit("invoices", data);

						if (!clientId) {
							storage.set(
								"downpayments_invoices",
								data,
								3600,
								app.id
							);
						}
					}
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		async searchInvoice({ rootState, commit, state }, parameters) {
			const { draw, searchValue } = parameters;
			if (state.searchedValues.find(value => value === searchValue) !== undefined)
				return true;

			try {
				const requestParams = {
					appId: rootState.app.id,
					"expand[0]": "contact",
					"order[0][name]": "number",
					"order[0][direction]": "desc",
					"search": searchValue,
					"draw": draw,
					"limit": 50
				};
				// filter on contactInfo if set
				if (rootState.contacts.contactInfos && rootState.contacts.contactInfos.type) {
					requestParams['filters[0][name]']       = `customer_${rootState.contacts.contactInfos.type}_id`;
					requestParams['filters[0][value]']      = rootState.contacts.contactInfos.id;
					requestParams['filters[0][comparator]'] = "=";

				}
				// send request
				const response = await query({
					operationId: 'app.documents.sales.invoices.list',
					params: requestParams
				});
				commit("addToInvoices", response.data);
				commit("updateSeachedValues", searchValue);

				return true;
			} catch (error) {
				this._vm.$bvToast.toast("Une erreur est survenue lors de la recherche de factures.", {
					title: "Erreur",
					variant: "danger",
					solid: true
				});
				console.log("error search invoices ", error);
			}
		}
	}
};

export default downpayment;
